/**
 * HTTP layer for feature flags. The feature catalog, billing feature
 * associations, and per-customer / per-site feature enablement including bulk
 * actions.
 *
 * Contains:
 * - fetchFeatures: feature catalog
 * - feature-association CRUD plus postFeatureBulkAction
 * - fetchAllowedCustomerFeatures / fetchCustomerFeatures / postCustomerFeatureAction / deleteCustomerFeature: customer features
 * - fetchAllowedSiteFeatures / fetchSiteFeatures / postSiteFeatureAction / deleteSiteFeature: site features
 */
import apiClient from '@sophocles/http-common';

export const fetchFeatures = queryParams =>
  apiClient.get(`/billing/features`, { params: queryParams }).then(res => res.data);

export const fetchFeatureAssociations = queryParams =>
  apiClient.get(`/billing/feature-associations/`, { params: queryParams }).then(res => res.data);

export const postFeatureAssociation = data =>
  apiClient.post(`/billing/feature-associations/`, data).then(res => res.data);

export const patchFeatureAssociation = (id, data) =>
  apiClient.patch(`/billing/feature-associations/${id}/`, data).then(res => res.data);

export const deleteFeatureAssociation = id => apiClient.delete(`/billing/feature-associations/${id}/`).then(res => id);

export const postFeatureBulkAction = data =>
  apiClient.post(`/billing/feature-associations/bulk-action/`, data).then(res => res.data);

// export const fetchFeatures = queryParams =>
//   apiClient.get(`${FEATURES_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

// export const fetchAllowedCustomerFeatures = (customerId, queryParams) =>
//   apiClient.get(`customers/${customerId}/allowed_features/`, { params: queryParams }).then(res => res.data);

// export const fetchCustomerFeatures = (customerId, queryParams) =>
//   apiClient.get(`customers/${customerId}/features/`, { params: queryParams }).then(res => res.data);

// export const postCustomerFeatureAction = (customerId, action, featureId) =>
//   apiClient.post(`/customers/${customerId}/features/`, { action, feature_id: featureId }).then(res => res.data);

// export const deleteCustomerFeature = (customerId, featureId) =>
//   apiClient.delete(`/customers/${customerId}/features/${featureId}/`).then(res => res.data);

// export const fetchAllowedSiteFeatures = (siteId, queryParams) =>
//   apiClient.get(`sites/${siteId}/allowed_features/`, { params: queryParams }).then(res => res.data);

// export const fetchSiteFeatures = (siteId, queryParams) =>
//   apiClient.get(`sites/${siteId}/features/`, { params: queryParams }).then(res => res.data);

// export const postSiteFeatureAction = (siteId, action, featureId) =>
//   apiClient.post(`/sites/${siteId}/features/`, { action, feature_id: featureId }).then(res => res.data);

// export const deleteSiteFeature = (siteId, featureId) =>
//   apiClient.delete(`/sites/${siteId}/features/${featureId}/`).then(res => res.data);
